'use strict';

angular.module('mean.general-tasks').directive('myCurrency', ['$filter',
	function($filter){
	return {
		require: 'ngModel',
		link: function(elem, $scope, attrs, ngModel){
            ngModel.$formatters.push(function(val){
                if(!val) val = 0;
                //console.log(val);
                var decimalPart = val.toString().split('.')[1];

                //no decimal part so just return $ 0.00
                if(!decimalPart)
                    return '$ ' + $filter('number')(val, 2);

                decimalPart = decimalPart.trim();
                if(decimalPart.length > 2) 
                    return '$ ' + $filter('number')(val, 2);
                else
                    return '$ ' + $filter('number')(val, 2);
            });
            ngModel.$parsers.push(function(val){
                //console.log(val);
                return Number(val.replace(/[^0-9\.-]+/g,""));
            });
        }
	};
}]);


// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/directives/generalTasks.js